module.exports = __webpack_public_path__ + "5a7f5a85a71703e4436af56db61c04e1.svg";